export class SelectableTileData {
  id: number;
  isSelected: boolean;
  isDisabled: boolean;
  isActive: boolean;
  isSystem: boolean;
  title: string;
  description: string;
}
